'use strict';

require('../../style/index.less');

require('./index.less');

require('../../checkbox/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/tree/style/index.tsx
 ** module id = 789
 ** module chunks = 0
 **/